export default "/images/e288aa61043918a7c300ce01b65d1f97.avif";